import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

/**
 * 隐藏移动端原生导航条
 * 这是从之前 manager-m/index.js 中挪过来的
 * @returns
 */
export function hideMqqNavigation() {
    if (!browser.isMobile) {
        return;
    }
    if (window.mqq && window.mqq.QQVersion !== '0') { // 判断是否是手机QQ TIM
        if (browser.isAndroid) {
            window.mqq.invoke('ui', 'setNavigationStatus', 0);
            if (browser.isTencentDocApp) {
                // 同时兼容部分android机型window.mqq.invoke('ui', 'setNavigationStatus', 0)这种写法不生效的情况，如redmi k40离线包
                window.mqq.invoke('ui', 'setNavigationStatus', { show: 0 });
            }
        } else if (browser.isIOS) {
            window.mqq.invoke('ui', 'setNavigationStatus', { show: 0 });
        }
    }
}

/**
 * 显示移动端原生导航条
 * 这是从之前 manager-m/index.js 中挪过来的
 * @returns
 */
export function showMqqNavigation() {
    if (!browser.isMobile) {
        return;
    }
    if (window.mqq && window.mqq.QQVersion !== '0') { // 判断是否是手机QQ TIM
        if (browser.isAndroid) {
            window.mqq.invoke('ui', 'setNavigationStatus', 1);
            if (browser.isTencentDocApp) {
                // 同时兼容部分android机型window.mqq.invoke('ui', 'setNavigationStatus', 1)这种写法不生效的情况，如redmi k40离线包
                window.mqq.invoke('ui', 'setNavigationStatus', { show: 1 });
            }
        } else if (browser.isIOS) {
            window.mqq.invoke('ui', 'setNavigationStatus', { show: 1 });
        }
    }
}

/**
 * 腾讯文档 app 中保留顶部刘海区域
 * @returns
 */
export function keepSafeAreaInTencentDocApp() {
    if (!browser.isMobile) {
        return;
    }
    if (browser.isTencentDocApp) {
        window.mqq.ui.setWebViewBehavior({
            safeArea: 1,
        });
    }
}
